import {showLoader} from "../utils/loader";
import {showPhase} from "../utils/phase";
import {handleResponse} from "../utils/responseHandler";
import {FORM_INPUTS} from "../utils/formInputs";
import {checkIfValid} from "./validations";
import {isFullDataForm} from "../main";
import {generateUserRequestData} from "../utils/userData";

export const submit3D = (transactionId, threeDS) => {
    if (checkIfValid()) return;

    const userUuid = document.getElementById('userUuid') ? document.getElementById('userUuid').value : window.userUuid;

    showLoader();

    const request = {
        "successUrl": window.location.href + "&status=success",
        "failUrl":  window.location.href + "&status=failure",
        "card": {
            "number": FORM_INPUTS.cardNumber.element.value.replace(/\s/g, ''),
            "code": FORM_INPUTS.cvv.element.value,
            "holder": FORM_INPUTS.cardHolder.element.value,
            "expiry": FORM_INPUTS.oneExpiryInput.element ? FORM_INPUTS.oneExpiryInput.element.value.replace('/', '20') : FORM_INPUTS.monthExpiry.element.value + FORM_INPUTS.yearExpiry.element.value
        },
        "browser": {
            "language": navigator.language,
            "screenHeight": screen.height,
            "screenWidth": screen.width,
            "screenColorDepth": screen.colorDepth,
            "timezone": new Date().getTimezoneOffset(),
            "userAgent": navigator.userAgent,
            "javaEnabled": navigator.javaEnabled(),
            "javaScriptEnabled": true
        },
        userUuid,
        "threeDS": {
            "transactionId": transactionId,
            "data": btoa(JSON.stringify(threeDS))
        }
    }

    if (isFullDataForm) {
        request.user = generateUserRequestData();
    }

    const xhttp = new XMLHttpRequest();
    xhttp.addEventListener('load', event => {
        handleResponse(event.target);
    });
    xhttp.addEventListener('error', function() {
        console.log("Payment failed");
        showPhase('Error');
    });
    xhttp.open('POST', '/v1/payments', true);
    xhttp.setRequestHeader('Content-type', 'application/json');
    xhttp.setRequestHeader('Accept', 'application/json');
    xhttp.send(JSON.stringify(request));
};